import { VideoConsultationNotificationConfiguration } from '@dreryk/egabinet-phone-notification-frontend-api';

import { PatientPhoneNotificationVideoConsultationReminderConfigurationFormBean } from './PatientPhoneNotificationVideoConsultationReminderConfigurationForm.types';

export const formInitializer = ({
   cancellationAfterEarlyNotificationEnabled,
   cancellationAfterLateNotificationEnabled,
   earlyNotificationEnabled,
   lateNotificationEnabled,
}: VideoConsultationNotificationConfiguration) => (): PatientPhoneNotificationVideoConsultationReminderConfigurationFormBean => ({
   cancellationAfterEarlyNotificationEnabled: cancellationAfterEarlyNotificationEnabled,
   cancellationAfterLateNotificationEnabled: cancellationAfterLateNotificationEnabled,
   earlyNotificationEnabled: earlyNotificationEnabled,
   lateNotificationEnabled: lateNotificationEnabled,
});
